import React from "react";
import PropTypes from "prop-types";
import Dashboard from "../../../components/Dashboard";
import {
  WizardTitle,
  notifyError,
  createSortByName,
  UnderConstruction,
  scrollToElement,
  USER_STATUS_IDS,
  isSpecialKDL,
} from "../../../components/Utils";
import { FormMenu } from "../../../components/Buttons";
import {
  setCompanyModel,
  getCompanyModel,
  setCompanyModelDelphi,
  renderWorkerDetailsMenu,
  setANPConnection,
} from "../components/Utils";

import BasicDataForm from "../components/wizard/BasicDataForm";
import ITConnectionForm from "../components/wizard/ITConnectionForm";
import CertificationListForm from "../components/wizard/CertificationListForm";
import UserDeviceListForm from "../../Device/components/UserDeviceListForm";
import TechKeyListForm from "../components/wizard/TechKeyListForm";
import UserTrainingPanel from "../components/panels/UserTrainingPanel";
import WorkerBasicDataMenu from "../components/WorkerBasicDataMenu";
// import ContractorCompanyPanel from "../components/panels/ContractorCompanyPanel";
// import UserTechDeviceListForm from "../../Device/components/UserTechDeviceListForm";
// import { TechKeyForm } from "../../Company/components";
// import { UserDeviceListPanel, UserRatingPanel } from "../components/panels";
// import AuditListForm from "../components/wizard/AuditListForm";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import {
  // loadExtendedRoles,
  initWorker,
  loadWorker,
  checkWorker,
  saveWorker,
  cancelWorker,
} from "../actions";
import { loadTechDevices } from "../../Device/actions";
import {
  PermissionGroupFetcher,
  PermissionResource,
  PermissionResourceList,
  PermissionSection,
  Resources,
} from "../../Permissions";
import {
  isResourceEditable,
  isResourceReadable,
} from "../../Permissions/actions";
import ITConnectionHeader from "../components/ITConnectionHeader";
import NGUMStatusObserver from "../../NGum/containers/NGUMStatusObserver";

const frontload = async (props) => {
  await props.getTechDevices();
  // await props.getExtendedRoles();
  const id = props.match.params.id;
  await props.getWorker({ id });
  await props.init(true);
};
const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    // permissions: state.permissions.permissionGroup.admindataaccess,
    permissions: state.permissions.permissionMap,
    isInitialized: state.worker.isInitialized,
    worker: state.worker.worker,
    userChecked: state.worker.userChecked,
    userExists: state.worker.userExists,
    roles: state.worker.roles,
    extendedRoles: state.worker.extendedRoles,
    kdls: state.worker.workerKDLs,
    userCompany: state.company.company,
    techDevices: state.device.techDevices,
    userTrainings: state.training.userTrainings,
    techKeyList: state.company.techKeys,
    // techKeyList: state.key.catalogKeys,
  };
};
const mapDispatchToProps = (dispatch) => ({
  init: (...args) => dispatch(initWorker(...args)),
  getTechDevices: (...args) => dispatch(loadTechDevices(...args)),
  getWorker: (...args) => dispatch(loadWorker(...args)),
  checkWorker: (...args) => dispatch(checkWorker(...args)),
  saveWorker: (...args) => dispatch(saveWorker(...args)),
  cancelWorker: (...args) => dispatch(cancelWorker(...args)),
});

class Wizard extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    user: PropTypes.shape({}),
    permissions: PropTypes.shape({}),
    workerPermissions: PropTypes.shape({}),
    initializing: PropTypes.bool,
    worker: PropTypes.shape({}),
    kdls: PropTypes.array,
    companies: PropTypes.array,
    userCompany: PropTypes.shape({}),
    userTrainings: PropTypes.array,
    roles: PropTypes.array.isRequired,
    techKeyList: PropTypes.array,
    extendedRoles: PropTypes.array.isRequired,
    init: PropTypes.func.isRequired,
    getTechDevices: PropTypes.func.isRequired,
    getWorker: PropTypes.func.isRequired,
    checkWorker: PropTypes.func.isRequired,
    saveWorker: PropTypes.func.isRequired,
    cancelWorker: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    userExists: PropTypes.bool,
    userChecked: PropTypes.bool,
    className: PropTypes.string,
  };
  static defaultProps = {
    className: "",
  };
  shouldComponentUpdate(nextProps) {
    return nextProps.isInitialized;
  }
  componentWillUnmount() {
    // reset state
    // console.log("WorkerWizard.componentWillUnmount() => canceling worker ...");
    this.props.cancelWorker();
  }
  onCheckWorker = (worker) => {
    this.props.checkWorker(worker);
  };
  onSave = () => {
    const { worker } = this.props;

    // ----------------------------------- //
    // Basic Info
    // ----------------------------------- //
    let baseData = this.baseData ? this.baseData.getModel() : null;
    if (!baseData && this.baseData) {
      return notifyError({
        summary: "Allgemeine Daten Fehler",
        detail: `Der Mitarbeiter konnte nicht gespeichert werden. Bitte Ihre Eingaben überprüfen.`,
      });
    }
    baseData = baseData || { ...worker };
    let model = { ...baseData };

    // ensure companies array exists with at least one company for proper saving of related data
    if (!model.companies || model.companies.length === 0) {
      return notifyError({
        summary: "Beschäftigungsfirma Fehler",
        detail: `Der Mitarbeiter muss mindestens eine Beschäftigungsfirma haben.`,
      });
    }

    // check if company was changed
    let isCompanyChanged = false;
    const companyChanges = [];
    for (const company of model.companies) {
      const isChanged = company.contractGiver !== company.oldContractGiver;
      if (isChanged) {
        companyChanges.push({
          oldContractGiver: company.oldContractGiver,
          newContractGiver: company.contractGiver,
        });
        isCompanyChanged = true;
      }
    }
    // for (const index in model.companies) {
    //   const isChanged =
    //     model.companies[index].name !== model.companies[index].oldName;
    //   if (isChanged) {
    //     // console.log(
    //     //   " >> Beschäftigungsfirma changed from",
    //     //   model.companies[index].oldName,
    //     //   "to",
    //     //   model.companies[index].name
    //     // );
    //     companyChanges.push({
    //       oldName: model.companies[index].oldName,
    //       newName: model.companies[index].name,
    //     });
    //     isCompanyChanged = true;
    //   }
    // }

    // VF Email
    const vfEmailModel = this.vfEmail ? this.vfEmail.getModel() : null;
    if (vfEmailModel) {
      model.vf_email = vfEmailModel.email;
    }

    // ----------------------------------- //
    // IT Connections
    // ----------------------------------- //
    const connectionData = this.itData ? this.itData.getModel() : null;
    console.log("ITData:", connectionData);
    if (connectionData) {
      const { delphiConnections, ...itConnectionData } = connectionData;

      // DELPHI Connections
      // validate delphi connections and assign to company
      if (delphiConnections && Array.isArray(delphiConnections)) {
        for (const delphiConnection of delphiConnections) {
          for (const company of model.companies) {
            if (delphiConnection.parentCompanyName !== company.contractGiver) {
              // delphiConnection could not be assigned to company => abort
              scrollToElement("delphi-zugaenge");
              return notifyError({
                summary: "Mitarbeiterprofil - DELPHI-Zugangsfehler",
                detail: `Der DELPHI-Zugang (KDL: ${delphiConnection.parentCompanyName}) konnte nicht zugewiesen werden.`,
              });
            }
          }
        }
        model.companies[0].delphiConnections = delphiConnections;
      }

      // JARVIS Connection
      // validate jarvis connection and assign to company
      const jarvisConnection = itConnectionData.jarvisConnection;
      if (jarvisConnection) {
        for (const company of model.companies) {
          if (jarvisConnection.parentCompanyName !== company.contractGiver) {
            scrollToElement("jarvis-zugang");
            return notifyError({
              summary: "Mitarbeiterprofil - JARVIS-Zugangsfehler",
              detail: `Der JARVIS-Zugang (KDL: ${jarvisConnection.parentCompanyName}) konnte nicht zugewiesen werden.`,
            });
          }
        }
      }

      // const unassignedDelphiConnection = setCompanyModelDelphi(
      //   model,
      //   delphiConnections,
      //   isCompanyChanged,
      //   companyChanges
      // );
      // if (unassignedDelphiConnection) {
      //   // delphiConnection could not be assigned to company => abort
      //   const kdlName = unassignedDelphiConnection.byCompanyName;
      //   const companyName = unassignedDelphiConnection.companyName;
      //   scrollToElement("it-zugaenge");
      //   return notifyError({
      //     summary: "Mitarbeiterprofil - DELPHI-Zugangsfehler",
      //     detail: `Der DELPHI-Zugang (KDL: ${kdlName}, Beschäftigungsfirma: ${companyName}) konnte nicht zugewiesen werden.`,
      //   });
      // }
      model.itConnectionData = itConnectionData;
      if (
        !isCompanyChanged &&
        worker.itConnectionData &&
        worker.itConnectionData.id
      ) {
        model.itConnectionData.id = worker.itConnectionData.id;
      }
    }

    // ----------------------------------- //
    // Tech Keys
    // ----------------------------------- //
    const techKeys = this.techKeys ? this.techKeys.getModel() : null;
    model.techKeys = techKeys;
    // ----------------------------------- //
    // Tech Devices
    // ----------------------------------- //
    if (this.userTechDevices) {
      const techDevices = this.userTechDevices
        ? this.userTechDevices.getModel()
        : null;
      // console.log("<< saving tech devices:", techDevices);
      if (techDevices) {
        const unassignedDevice = setCompanyModel(
          model,
          techDevices,
          "techDevices",
          "companyName",
          isCompanyChanged,
        );
        if (unassignedDevice) {
          // tech device could not be assigned to company => abort
          const companyName = unassignedDevice.companyName;
          scrollToElement("vkdg-geraete");
          return notifyError({
            summary: "Mitarbeiterprofil - Technikergerätfehler",
            detail: `Das Technikergerät (${unassignedDevice.device}, Beschäftigungsfirma: ${companyName}) konnte nicht zugewiesen werden.`,
          });
        }
      }
    }
    // ----------------------------------- //
    // Certifications
    // ----------------------------------- //
    const certificates = this.certificates
      ? this.certificates.getModel()
      : null;
    if (certificates) {
      model.certificates = certificates;
    }
    // }
    if (worker.id) {
      model.id = worker.id;
    }
    console.log("Saving Model:", model);
    const { history } = this.props;
    const onSuccess = () => history.replace("/organisation/mitarbeiter");
    this.props.saveWorker(model, onSuccess);
  };
  onCancel = () => {
    this.props.cancelWorker();
    this.props.history.replace("/organisation/mitarbeiter");
  };
  getUserDeviceListBaseData = () => {
    const { worker } = this.props;
    const baseData = this.baseData.getModel(true);
    console.log("WorkerWizard.getUserDeviceListBaseData()", baseData);
    return {
      currentWorker: worker,
      currentWorkerCompany:
        baseData.companies.length > 0 ? baseData.companies[0] : null,
    };
  };
  getUserTechDeviceListBaseData = () => {
    const { techDevices, companies } = this.props;
    return { techDevices, companies };
  };
  getCompanyData = () => {
    let companyData = { isContractor: false };
    if (this.baseData) {
      companyData = this.baseData.getCompanyData();
    }
    return companyData;
  };
  getEmployeeData = () => {
    let employeeData = { email: "" };
    if (this.baseData) {
      const model = this.baseData.getModel();
      if (model) {
        employeeData = model;
      }
    }
    return employeeData;
  };
  isWorkerEditable = () => {
    const { worker, permissions } = this.props;
    const resourceKeys = Object.keys(Resources.Organisation.WorkerWizard);
    console.log(
      "WorkerWizard.isWorkerEditable()",
      resourceKeys,
      worker,
      permissions,
    );
    for (const key of resourceKeys) {
      const isWriteable = isResourceEditable(
        Resources.Organisation.WorkerWizard[key],
        permissions,
      );
      if (isWriteable) {
        return (
          !worker.status_id || worker.status_id === USER_STATUS_IDS.APPROVED
        );
      }
    }
    return false;
  };
  render() {
    const {
      className,
      permissions,
      worker,
      kdls,
      userCompany,
      roles,
      extendedRoles,
      userChecked,
      techKeyList,
      disabled,
    } = this.props;
    if (!worker) return null;

    // user check status
    const canReadAdminData = isResourceReadable(
      Resources.AdminDataAccess,
      permissions,
    );
    const userExists = worker.id !== undefined || this.props.userExists;

    // main company
    const mainCompany =
      worker.companies.length === 1
        ? worker.companies[0]
        : worker.companies.find((item) => item.role && item.role !== "");
    const isDL = isSpecialKDL({type_id: mainCompany.parentCompanyTypeId });
    console.log("WorkerWizard.render() mainCompany:", mainCompany, "isDL:", isDL);
    // if (mainCompany && mainCompany.name === "" && companies.length === 1) {
    //   mainCompany = { ...companies[0] };
    // }

    const kdlCompanyList = kdls.sort(createSortByName());

    const flag = Boolean((worker.id !== undefined || userChecked) && worker.id);
    const Menu = renderWorkerDetailsMenu(flag);

    // IT Connections
    const itConnectionData = worker.itConnectionData || {};
    let visibleDelphiCompanies = null;
    itConnectionData.delphiConnections = getCompanyModel(
      worker,
      "delphiConnections",
      visibleDelphiCompanies,
    );
    itConnectionData.vfEmail = worker.vf_email;
    itConnectionData.isAutheticatorRegistered = worker.hasMsAuthenticator;
    // Devices
    const userDevices = getCompanyModel(worker, "devices");
    // // Tech Devices
    // const userTechDevices = getCompanyModel(worker, 'techDevices');
    const userDisabled = !this.isWorkerEditable();
    console.log(
      "WorkerWizard.render() worker:",
      worker,
      "userDisabled:",
      userDisabled,
      "techKeyList:",
      techKeyList,
    );
    return (
      <div className={`worker-wizard clearfix ${className}`}>
        <PermissionGroupFetcher group="Organisation.WorkerWizard" />
        <WizardTitle
          type="worker"
          model={worker}
          menu={
            <FormMenu
              className="pad-big-top"
              onSave={this.onSave}
              onCancel={this.onCancel}
              saveDisabled={!worker.id && userChecked === false}
              saveBtnName="saveWorkerBtn2"
              cancelBtnName="cancelWorkerBtn2"
              saveHidden={disabled || userDisabled}
              cancelBtnLabel={userDisabled ? "Schließen" : undefined}
            />
          }
        />
        <div className="container">
          <Dashboard menu={Menu} menuSize={3} key={Math.random()}>
            <PermissionResource
              resource={Resources.Organisation.WorkerWizard.BasicInfo}
            >
              <PermissionSection
                height="30"
                id="basisdaten"
                className="w3-border margin-big-top pad-big"
                isUnterWizardTitle
              >
                <NGUMStatusObserver>
                  <WorkerBasicDataMenu className="w3-right" user={worker} />
                </NGUMStatusObserver>
                <h3 className="no-margin-top">{"Persönliche Daten"}</h3>
                <BasicDataForm
                  ref={(ref) => (this.baseData = ref)}
                  model={worker}
                  kdlCompanyList={kdlCompanyList}
                  contractGivers={worker.contractGivers}
                  userCompany={userCompany}
                  roleList={roles}
                  extendedRoleList={extendedRoles}
                  checkUser={this.onCheckWorker}
                  userChecked={userChecked}
                  userExists={userExists}
                  canReadAdminData={canReadAdminData}
                  readOnly={userDisabled}
                />
              </PermissionSection>
            </PermissionResource>
            {flag && (
              <>
                <PermissionResource
                  resource={Resources.Organisation.WorkerWizard.IDCard}
                >
                  <PermissionSection
                    height="30"
                    id="vkdg-ausweis"
                    className="w3-border margin-big-top pad-big"
                    isUnterWizardTitle
                  >
                    <h3 className="no-margin-top">{"VKDG Ausweis"}</h3>
                    <UnderConstruction />
                  </PermissionSection>
                </PermissionResource>
                <PermissionResourceList
                  resources={[
                    Resources.Organisation.WorkerWizard.ADConnections,
                    Resources.Organisation.WorkerWizard.ANPAccount,
                    Resources.Organisation.WorkerWizard.PTConnections,
                    Resources.Organisation.WorkerWizard.DelphiConnections,
                    Resources.Organisation.WorkerWizard.JarvisConnection,
                  ]}
                >
                  <PermissionSection
                    height="30"
                    id="it-zugaenge"
                    className="w3-border margin-big-top"
                    isUnterWizardTitle
                  >
                    <ITConnectionHeader
                      title={"IT-Zugänge"}
                      targetId="itConnectionHeaderEnd"
                      targetPosition={160 + 74} // 160px for header + 74px for sticky header
                      isSticky
                    />
                    <ITConnectionForm
                      ref={(ref) => (this.itData = ref)}
                      className="pad-big-lr pad-big-btm-"
                      model={{
                        ...itConnectionData,
                        vf_email: worker.vf_email,
                        isAutheticatorRegistered: worker.hasMsAuthenticator,
                      }}
                      kdlCompanyList={worker.contractGivers}
                      userCompany={userCompany}
                      canReadAdminData={canReadAdminData}
                      vfEmailPermission={
                        permissions[
                          Resources.Organisation.WorkerWizard.VodafoneEmail
                        ]
                      }
                      ngumUserIdPermission={
                        permissions[
                          Resources.Organisation.WorkerWizard
                            .ADConnectionNGUMStatusID
                        ]
                      }
                      disabled={disabled}
                      roleList={roles}
                      getCompanyData={this.getCompanyData}
                      getEmployeeData={this.getEmployeeData}
                      userDisabled={userDisabled}
                      isDL={isDL}
                    />
                    <div id="itConnectionHeaderEnd" />
                  </PermissionSection>
                </PermissionResourceList>
                <PermissionResource
                  resource={Resources.Organisation.WorkerWizard.UserDevices}
                >
                  <PermissionSection
                    height="30"
                    id="messgeraete"
                    className="w3-border margin-big-top pad-big"
                    isUnterWizardTitle
                  >
                    {/* <UserDeviceListPanel model={userDevices} /> */}
                    <UserDeviceListForm
                      ref={(ref) => (this.userDevices = ref)}
                      model={userDevices}
                      getBaseData={this.getUserDeviceListBaseData}
                      readOnly
                    />
                  </PermissionSection>
                </PermissionResource>
                <PermissionResource
                  resource={Resources.Organisation.WorkerWizard.TechKeys}
                >
                  <PermissionSection
                    height="30"
                    id="schluessel"
                    className="w3-border margin-big-top pad-big"
                    isUnterWizardTitle
                  >
                    <TechKeyListForm
                      ref={(ref) => (this.techKeys = ref)}
                      model={worker.techKeys}
                      company={mainCompany}
                      companyKeys={techKeyList || []}
                      readOnly={userDisabled}
                    />
                  </PermissionSection>
                </PermissionResource>
                <PermissionResource
                  resource={Resources.Organisation.WorkerWizard.Certifications}
                >
                  <PermissionSection
                    height="30"
                    id="zertifizierungen"
                    className="w3-border margin-big-top pad-big"
                    isUnterWizardTitle
                  >
                    <CertificationListForm
                      ref={(ref) => (this.certificates = ref)}
                      model={worker.certificates}
                      readOnly={userDisabled}
                    />
                  </PermissionSection>
                </PermissionResource>
                <PermissionResource
                  resource={Resources.Organisation.WorkerWizard.TechDevices}
                >
                  <PermissionSection
                    height="30"
                    id="vkdg-geraete"
                    className="w3-border margin-big-top pad-big"
                    isUnterWizardTitle
                  >
                    <h3 className="no-margin">
                      {"VKDG Geräte / Technikergeräte"}
                    </h3>
                    <UnderConstruction />
                    {/* <UserTechDeviceListForm 
                    ref={ref => this.userTechDevices = ref}
                    model={userTechDevices}
                    getBaseData={this.getUserTechDeviceListBaseData
                  /> */}
                  </PermissionSection>
                </PermissionResource>
                <PermissionResource
                  resource={Resources.Organisation.WorkerWizard.Seminars}
                >
                  <PermissionSection
                    height="30"
                    id="schulungen"
                    className="w3-border margin-big-top pad-big"
                    isUnterWizardTitle
                  >
                    <h3 className="no-margin-top">{"Schulungen"}</h3>
                    <UserTrainingPanel model={worker.trainings} isEditable />
                  </PermissionSection>
                </PermissionResource>
                <PermissionResource
                  resource={Resources.Organisation.WorkerWizard.Audits}
                >
                  <PermissionSection
                    height="30"
                    id="auditierung"
                    className="w3-border margin-big-top pad-big"
                    isUnterWizardTitle
                  >
                    <h3 className="no-margin-top">{"Auditierung"}</h3>
                    <UnderConstruction />
                    {/* <AuditListForm
                    ref={ref => this.audits = ref}
                    model={worker.audits}
                  /> */}
                  </PermissionSection>
                </PermissionResource>
                <div id="WorkerWizardEnd" />
              </>
            )}
            <FormMenu
              className="w3-border margin-big-top pad-big w3-light-grey"
              onSave={this.onSave}
              onCancel={this.onCancel}
              saveDisabled={!worker.id && userChecked === false}
              saveBtnName="saveWorkerBtn"
              cancelBtnName="cancelWorkerBtn"
              saveHidden={disabled || userDisabled}
              cancelBtnLabel={userDisabled ? "Schließen" : undefined}
            />
          </Dashboard>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(Wizard),
);
